import React from 'react'
import PropTypes from 'prop-types'
import style from './style.module.scss'
import FlagTeam from '@assets/images/placeholder/team-placeholder.jpg'
import { getImgURL } from '@shared-submodule/utils'
import HItTracker from './HItTracker'
import CustomLink from '@shared/components/customLink'
import MyImage from '@shared/components/myImage'

function PlayerRow({ player, isLast, statType, isMobile = false }) {
  return (
  <>
    <div className="d-flex align-items-center justify-content-between px-3 py-2">
      {!isMobile ? (
        <CustomLink href={`${player?.oPlayer?.oSeo?.sSlug}`}>
          <a>
            <div className="d-flex align-items-center gap-2 cursor-pointer">
              <MyImage
                src={getImgURL(player?.oPlayer?.oImg?.sUrl) || FlagTeam}
                alt={player?.name}
                width={30}
                height={30}
                className="rounded-circle"
              />
              <span>{player?.oPlayer?.sFullName}</span>
            </div>
          </a>
        </CustomLink>
      ) : (
        <div className="d-flex align-items-center gap-2">
          <MyImage
            src={getImgURL(player?.oPlayer?.oImg?.sUrl) || FlagTeam}
            alt={player?.name}
            width={30}
            height={30}
            className="rounded-circle"
          />
          <span>{player?.oPlayer?.sFullName}</span>
        </div>
      )}
      <span>{player?.nCount}</span>
    </div>
    {!isLast && <div className={style.line}></div>}
  </>
  )
}

PlayerRow.propTypes = {
  player: PropTypes.array,
  isLast: PropTypes.bool.isRequired,
  statType: PropTypes.string.isRequired,
  isMobile: PropTypes.bool
}

function BoundaryBox({ title, statType, totalHits, playerData, isMobile = false }) {
  return (
    <div className={style.boundaryBox}>
      <div className={style.themeImg}>
        <span className={style.countText}>{title}</span>
      </div>
      <div className={style.flipSection}>
        <HItTracker totalHits={totalHits} />
      </div>
      <div className={`p-0 ${style.line}`}></div>
      <div className={style.leaderboard}>
        <h4 className='m-0 px-2'>Leaderboard</h4>
        <div className={`d-flex justify-content-between p-3 font-bold text-primary fs-base mt-2 ${style.playerBg}`} >
          <span>Players</span>
          <span>{`${title.split("'")[0]}'s`}</span>
        </div>
        {playerData ? (playerData.map((player, i) => (<>
          <PlayerRow
            key={i}
            player={player}
            isLast={i === playerData.length - 1}
            statType={statType}
            isMobile
          />
        </>
        ))) : (
          <p className='text-center p-3' style={{ fontWeight: '600' }}>Tournament Starting Shortly</p>
        )}
      </div>
    </div>
  )
}

BoundaryBox.propTypes = {
  title: PropTypes.string.isRequired,
  statType: PropTypes.string.isRequired,
  totalHits: PropTypes.number,
  playerData: PropTypes.array,
  isMobile: PropTypes.bool
}

function BoundaryTracker({ fourSixHits, isMobile = false }) {
  const totalFour = fourSixHits?.nTotalFours
  const totalSix = fourSixHits?.nTotalSixes
  const teamFour = fourSixHits?.aPlayerFours.slice(0, 5)
  const teamSix = fourSixHits?.aPlayerSixes.slice(0, 5)
  return (
    <div className='mt-4'>
      <h4>Boundary Tracker</h4>
      <div className={style.boundary_box}>
        <BoundaryBox title={"4's Counter"} statType="fours" totalHits={totalFour} playerData={teamFour} />
        <BoundaryBox title={"6's Counter"} statType="sixes" totalHits={totalSix} playerData={teamSix} />
      </div>
    </div>
  )
}

BoundaryTracker.propTypes = {
  fourSixHits: PropTypes.object,
  isMobile: PropTypes.bool
}

export default BoundaryTracker
